var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 418.276,
    height: 313.708,
    viewBox: "0 0 418.276 313.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor",
    transform: "translate(0 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22310",
    "data-name": "Group 22310",
    transform: "translate(0 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24274",
    "data-name": "Path 24274",
    d: "M383.42,64H34.857A34.9,34.9,0,0,0,0,98.857V307.995a34.9,34.9,0,0,0,34.857,34.857H183v17.428H130.711a8.714,8.714,0,0,0,0,17.429H287.565a8.714,8.714,0,0,0,0-17.429H235.28V342.851H383.42a34.9,34.9,0,0,0,34.857-34.857V98.857A34.9,34.9,0,0,0,383.42,64ZM217.852,360.279H200.425V342.851h17.428Zm183-52.285a17.446,17.446,0,0,1-17.428,17.428H34.857a17.445,17.445,0,0,1-17.428-17.428V98.857A17.446,17.446,0,0,1,34.857,81.429H383.42a17.445,17.445,0,0,1,17.428,17.428Z",
    transform: "translate(0 -64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPreview);
export default __webpack_public_path__ + "static/media/desktop-preview.d4704e22a060b623d29bac8d5752c5e9.svg";
export { ForwardRef as ReactComponent };